exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body .select-form-control{width:100%;margin-top:6px;margin-bottom:6px}body .select-form-control>div>div{text-align:left}body .select-form-control>div>div>div:focus{background:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Select/style.scss
// module id = 1528
// module chunks = 0